import React, { PropTypes } from 'react';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';

// components
import NavbarThumb from './NavbarThumb';

// icons
import { icon } from './../../icons/icons';

export const DragHandle = SortableHandle(() => <div className="icon icon-nobg page__move" title="Move">{ icon.move()}</div>);

const SortableItem = SortableElement(({ pagesList, page, actions, index }) => {
    return <NavbarThumb index={index} pagesList={pagesList} page={page} actions={actions} />;
});

const SortableList = SortableContainer(({ pagesList, pages, actions }) => {
    return (
        <ul className="pages__list">
            {pagesList.map((id, index) => {
                const page = pages[id];
                if (page.id === 1 || page.id === 3) {
                    return (
                        <SortableItem disabled key={page.id} index={index} pagesList={pagesList} page={page} actions={actions} />
                    );
                } else {
                    return (
                        <SortableItem key={page.id} index={index} pagesList={pagesList} page={page} actions={actions} />
                    );
                }
            }
            )}
        </ul>
    );
});

const NavbarList = (props) => {
    const { pages, pagesList, actions } = props;
    const onSortEnd = ({ oldIndex, newIndex, collection }, e) => {
        actions.sortPages(oldIndex, newIndex);
    };

    return (
        <SortableList useDragHandle onSortEnd={onSortEnd} pages={pages} pagesList={pagesList} actions={actions} />
    );
};

NavbarList.propTypes = {
    pagesList: PropTypes.array.isRequired,
    pages: React.PropTypes.objectOf(React.PropTypes.object),
    actions: PropTypes.object.isRequired,
};

export default NavbarList;



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Navbar/NavbarList.jsx